import { Col, Input, Row, List, Menu } from "antd";
import { FaPhoneAlt, FaRegClock } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { FaRegEnvelope, FaYelp } from "react-icons/fa6";
import { ImageUrl } from "../../config/helper";
import { Link, useNavigate } from "react-router-dom";
// import ScrollToTop from "./ScrollToTop";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <Row
        justify="center"
        className="py-16"
        style={{ backgroundColor: "#323131" }}
      >
        <Col lg={18}>
          <Row>
            <Col lg={6}>
              <div>
                <img src={ImageUrl("logo.png")} alt="vector" className="" />
                <h3 className="font-goldman text-white xldesktop:text-[26px] xldesktop:leading-9 py-3">
                  We make sure that your every trip is comfortable
                </h3>
              </div>

              <h4 className="text-[#666666] text-[16px] antialiased py-4">
                Follow Us:
              </h4>
              <div className="footer-social-box">
                <FaFacebookF className="s-icon" />
                <FaInstagram className="s-icon" />
                <FaXTwitter className="s-icon" />
                <FaYelp className="s-icon" />
              </div>
            </Col>
            <Col lg={6}>
              <h4 className="font-goldman text-white xldesktop:text-[25px] xldesktop:leading-9 py-3 px-4">
                Quick Links
              </h4>
              <Menu mode="vertical" className="footer-nav">
                <Menu.Item className="antialiased" key="about-us">
                  <Link to="/aboutUs">Bachelor Parties</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Bachelorette Parties</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Proms</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Graduations</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Sweet Sixteen</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Casinos & Gambling</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Any Special Occasions</Link>
                </Menu.Item>
              </Menu>
            </Col>
            <Col lg={6}>
              <h4 className="font-goldman text-white xldesktop:text-[25px] xldesktop:leading-9 py-3 px-4">
                legal info
              </h4>
              <Menu mode="vertical" className="footer-nav">
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">FAQ’s</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Privacy Policy</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Refund Policy</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Terms & Conditions</Link>
                </Menu.Item>
              </Menu>
            </Col>
            <Col lg={6}>
              <h4 className="font-goldman text-white xldesktop:text-[25px] xldesktop:leading-9 py-3 px-4">
                Contact info
              </h4>
              <Menu mode="vertical" className="footer-nav">
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Support Center 24/7</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">(862) 666-4329</Link>
                </Menu.Item>
                <Menu.Item key="about-us">
                  <Link to="/aboutUs">Email: info@luxuryccs.com</Link>
                </Menu.Item>
              </Menu>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        justify="center"
        className="py-5"
        style={{ backgroundColor: "#000" }}
      >
        <Col lg={18}>
          <Row>
            <Col lg={12}>
              <p className="rights-p">
                @ 2024 <span>Luxury Car Chauffeur Service</span>. All Rights
                Reserved.
              </p>
            </Col>
            <Col lg={12}>
              <div className="paycards">
                <img src={ImageUrl("paycards.png")} alt="vector" className="" />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Footer;
